/*
--------------------------------------
components/GoesGreatWith.ts
--------------------------------------
*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class ShopTheLook extends ThemeComponent {

}
